import classNames from "classnames";
import "react-calendar/dist/Calendar.css";
import { default as Calendar } from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import { ElementWithWrapper } from "../inputs/Input";
import "./calendar.scss";

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

function DatePicker({
  label,
  disabled,
  value,
  onChange,
  className,
  error,
  required,
}: {
  label: string;
  disabled?: boolean;
  value: ValuePiece;
  onChange: (value: Value) => void;
  className?: string;
  error?: string;
  required?: boolean;
}) {
  return (
    <ElementWithWrapper label={label} error={error} required={required}>
      <Calendar
        onChange={onChange}
        value={value}
        calendarIcon={null}
        className={classNames(
          "flex items-center h-[46px] w-full px-[20px] rounded-[5px] border-[1px] border-lightGrey gap-3",
          { "bg-white-ghost cursor-not-allowed": disabled },
          className
        )}
        disabled={disabled}
      />
    </ElementWithWrapper>
  );
}

export default DatePicker;
